<template>
  <div class="user-setting">
    <div class="user-setting-box">
      <el-dropdown trigger="click" @command="clickDown" style="height: 43px">
        <div class="el-dropdown-link">
          <!-- <img class="user" src="../../assets/images/user.png" alt=""> -->
          <span
            :style="{
              color:
                $store.state.theme.activeName === 'block'
                  ? '#b1d3fb'
                  : '#606266',
            }"
            >{{ displayName }} <i class="el-icon-caret-bottom el-icon--right"
          /></span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">
            <svg-icon icon-class="exit" />&nbsp;{{
              $t("components.HeaderSetting.changethepassword")
            }}
          </el-dropdown-item>
          <el-dropdown-item command="2">
            <svg-icon icon-class="password" />&nbsp;{{
              $t("components.HeaderSetting.logout")
            }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
      width="40%"
    >
      <dialog-header
        slot="title"
        :title="$t('components.HeaderSetting.changethepassword')"
        @close="closeDia"
      />
      <vue-linetitle>
        <el-form
          ref="form"
          label-suffix="："
          label-position="right"
          :model="formInfo"
          :rules="rules"
          :label-width="$t('components.HeaderSetting.inputlabelwidth')"
        >
          <el-form-item
            :label="$t('components.HeaderSetting.enter1')"
            prop="oldpwd"
          >
            <el-input
              v-model="formInfo.oldpwd"
              type="password"
              maxlength="20"
              clearable
              :placeholder="$t('components.HeaderSetting.enter1')"
            />
          </el-form-item>
          <el-form-item
            :label="$t('components.HeaderSetting.enter2')"
            prop="newpwd"
          >
            <el-input
              v-model="formInfo.newpwd"
              type="password"
              maxlength="20"
              clearable
              :placeholder="$t('components.HeaderSetting.enter2')"
            />
          </el-form-item>
          <el-form-item
            :label="$t('components.HeaderSetting.enter3')"
            prop="agianNewpwd"
          >
            <el-input
              v-model="formInfo.agianNewpwd"
              type="password"
              maxlength="20"
              clearable
              :placeholder="$t('components.HeaderSetting.enter3')"
              @keyup.enter.native="submitForm"
            />
          </el-form-item>
        </el-form>
      </vue-linetitle>
      <div style="height: 8px"></div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel" type="primary" @click="headleCancel">{{
          $t("public.cancel")
        }}</el-button>
        <el-button type="primary" @click="submitForm">{{
          $t("public.define")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { partialForm } from '@/mixins/partialForm'
import { changedpwd } from '@/api/login'
export default {
  name: 'Headersetting',
  mixins: [partialForm],
  data() {
    const validateOldpwd = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('components.HeaderSetting.error1')))
      }
    }
    const validateNewpwd = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('components.HeaderSetting.error2')))
      }
      // 输入6位以上
      if (!/^\S{6,}$/.test(value)) {
        return cb(new Error(this.$t('components.HeaderSetting.error3')))
      }
    }
    const validateAgianNewpwd = (rule, value, cb) => {
      if (value !== this.formInfo.newpwd) {
        return cb(new Error(this.$t('components.HeaderSetting.error4')))
      }
      if (!value) {
        return cb(new Error(this.$t('components.HeaderSetting.error5')))
      }
    }
    return {
      collapse: false,
      show: false,
      formInfo: {
        oldpwd: '',
        newpwd: '',
        agianNewpwd: ''
      },
      rules: {
        oldpwd: [
          { required: true, trigger: 'blur', validator: validateOldpwd },
          { trigger: 'change', validator: validateOldpwd }
        ],
        newpwd: [
          { required: true, trigger: 'blur', validator: validateNewpwd },
          { trigger: 'change', validator: validateNewpwd }
        ],
        agianNewpwd: [
          { required: true, trigger: 'blur', validator: validateAgianNewpwd },
          { trigger: 'change', validator: validateAgianNewpwd }
        ]
      },
      userNameList: ['channelName', 'companyName', 'departmentName', 'subCompanyName']
    }
  },
  computed: {
    loginName() {
      return this.$store.state.user.userInfo.loginName
    },
    displayName() {
      let leftName = ''
      this.userNameList.forEach((v) => {
        if (this.$store.state.user.userInfo[v]) {
          leftName = this.$store.state.user.userInfo[v]
        }
      })
      return leftName
        ? `${leftName} | ${this.loginName}`
        : this.loginName
    }
  },
  methods: {
    restForm() {
      this.$refs['form'].resetFields()
    },
    clickDown(e) {
      switch (e) {
        case '1':
          this.show = true
          this.collapse = !this.collapse
          break
        case '2':// 退出登录
          this.$store.dispatch('logout')
            .then(() => {
              location.reload()
            })
          break
        default:
          break
      }
    },
    closeDia() {
      this.restForm()
      this.show = false
    },
    submitForm() {
      const check = this.checkForm({ formName: 'form', formList: ['oldpwd', 'newpwd', 'agianNewpwd'] })
      if (!check) {
        return
      }
      const data = {
        userid: this.$store.state.user.userInfo.userId,
        oldpwd: this.formInfo.oldpwd,
        pwd: this.formInfo.newpwd
      }
      changedpwd(data).then(({ data }) => {
        if (data.code === 0) {

          this.$message.success({
            message: this.$t('components.HeaderSetting.message1'),
            duration: 2 * 1000
          })
          this.show = false
          this.restForm()
          // 修改密码后重新登录
          this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/login')
            })
        }
      }).catch(() => {
        this.$message.error({
          message: this.$t('components.HeaderSetting.message2'),
          duration: 2 * 1000
        })
        this.show = false
        this.restForm()
      })
    },
    headleCancel() {
      this.show = false
      this.restForm()
    }

  }
}
</script>
<style lang="scss" scoped>
.user-setting {
  .user-setting-box {
    display: inline-block;
    padding: 0 12px 0 0;
    line-height: 53px;
    .el-dropdown-link {
      line-height: 30px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      .user {
        margin-right: 5px;
        width: 29px;
        height: 29px;
        border-radius: 50%;
      }
    }
  }
}
</style>
